// src/amplify.ts
import { Amplify } from "aws-amplify";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_DOMAIN,
          scopes: ["openid", "email", "profile"],
          redirectSignIn: [
            `${process.env.REACT_APP_REDIRECT_BASE}/aixcloud`,
          ],
          redirectSignOut: [
            `${process.env.REACT_APP_REDIRECT_BASE}/aixcloud/signout`,
          ],
          responseType: "code",
        },
      },
    },
  },
});
